const itemsData = {
  Id: 0,
  boxLines: [
    {
      rowList: [
        { title: "收货人:", banding: "Name", value: "" },
        { title: "手机号: ", banding: "Mobile", value: "" }
      ]
    },
    {
      rowList: [{ title: "收货公司: ", banding: "CompanyName", value: "" }]
    },
    {
      rowList: [
        {
          title: "收货地址: ",
          banding: "FullAddress",
          value: ""
        }
      ]
    },
    {
      rowList: [
        { title: "收货时间: ", banding: "Remark", value: "" },
        {
          title: "是否禁用:  ",
          banding: "IsDefault",
          value: "",
          dataType: "Type",
          dataMap: { true: "已禁用", false: "未禁用" }
        }
      ]
    }
  ]
};
export { itemsData };
